import { z } from 'zod';
/**
 * The closed vocabularies of the sensitive-identifier module (ADR-012 §4–§5).
 *
 * This file imports nothing from the rest of the package, so the audit vocabulary can depend
 * on it without a cycle (people/audit.ts → here, sensitive/document.ts → people/audit.ts).
 */
/** The two sensitive identifiers. Audit rows and the reveal call name one of these, never a value. */
export const sensitiveFieldSchema = z.enum(['ssn', 'dateOfBirth']);
/**
 * Why HR revealed a value (ADR-012 §4). CLOSED on purpose: free text is where somebody types
 * the number, so there is no free-text reason and `other` is the escape hatch.
 */
export const revealPurposeSchema = z.enum([
    'background-check',
    'sworn-disclosure-correction',
    'payroll-setup',
    'identity-correction',
    'other',
]);
/**
 * What a `person.sensitive-revealed` audit row records: the field and the purpose code. The
 * value, masked or not, has no place here — `strict` refuses any extra key.
 */
export const sensitiveRevealAuditDetailsSchema = z
    .object({ field: sensitiveFieldSchema, purpose: revealPurposeSchema })
    .strict();
//# sourceMappingURL=vocabulary.js.map